import * as React from 'react'
import { SurchargeAmounts, TransactionPageProps } from './ResponsePage'

interface AmountsDisplayProps {
  props: TransactionPageProps;
  surchargeAmounts?: SurchargeAmounts;
  isDeclined?: boolean;
  isPartialApproval?: boolean;
  approvedAmount?: number | string;
  notApprovedAmount?: number | string;
}

export function AmountsDisplay ({
  props,
  surchargeAmounts,
  isDeclined = false,
  isPartialApproval = false,
  approvedAmount,
  notApprovedAmount,
}: AmountsDisplayProps) {
  if (isPartialApproval) {
    return (
      <div className="amount-container">
        <h2 className="amount-value">
          ${Number(approvedAmount).toFixed(2)} processed
        </h2>
        <h2 className="amount-value amount-declined amount-unprocessed">
          ${Number(notApprovedAmount).toFixed(2)} not processed
        </h2>
      </div>
    )
  }

  const declineClass = isDeclined ? 'amount-declined' : ''
  const declineText = isDeclined ? ' - Not Processed' : ''

  if (props.include_surcharge && surchargeAmounts) {
    return (
      <div className="amount-container">
        <h2 className={`amount-value ${declineClass}`}>
          ${Number(surchargeAmounts.totalAmount).toFixed(2)}
          {declineText}
        </h2>
        <div className="amount-surcharge-details">
          Base: ${Number(surchargeAmounts.transactionAmount).toFixed(2)} &nbsp;|&nbsp;
          Surcharge: ${Number(surchargeAmounts.surchargeAmount).toFixed(2)}
        </div>
      </div>
    )
  }

  return (
    <div className="amount-container">
      <h2 className={`amount-value ${declineClass}`}>
        ${Number(props.amount).toFixed(2)}
        {declineText}
      </h2>
    </div>
  )
}
